module.exports = __webpack_public_path__ + "img/ltr_completed_960.05d7c6ed.png";